import React from "react";

function Name(params) {
    return(
        <div className="nameheading">
            <div className="quote">
                <i className="ri-arrow-down-fill down-arrow"></i>
                <h2>I Love To learn &</h2>
                <h2>adopt new things</h2>
            </div>
            <div className="name">
                <h2>SHAZIL</h2>
                <h2>KHAN</h2>
            </div>
        </div> 
    )

}

export default Name;